import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Row, Stack } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { deleteGuardian, deleteMember, postNote } from "../../services/httpClient";
import { User } from "../../types/user";
import ExitNote from "./ExitNote";
import { Member } from "../../types/member";

interface DeleteState {
  setIsDeleting: any;
  userToDelete: User | Member | undefined;
  type: string | undefined;
  onDone: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const ConfirmDelete = ({ setIsDeleting, userToDelete, type, onDone, setShowToast, setToastText, setToastBody }: DeleteState) => {
  const { id } = useParams();
  const [exitDate, setExitDate] = useState<string>(new Date().toISOString().split("T")[0]);
  const [exitNote, setExitNote] = useState<string>();
  const [exitType, setExitType] = useState<string>("voluntary");
  const name = userToDelete && `${userToDelete.firstname} ${userToDelete.lastname}`;

  const mainRef = useRef();

  const handleScroll = (ref: any) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "instant", block: "end", inline: "nearest" });
    }
  };

  useEffect(() => {
    handleScroll(mainRef);
  }, []);

  const onClickDeleteFinalWExit = () => {
    if (type === "Guardian") {
      const note = {
        notetype: "exit",
        subject: {
          id: userToDelete?.id,
          type: "guardian",
        },
        fields: {
          exit_type: exitType,
          description: exitNote,
          date: new Date().toISOString().split("T")[0],
        },
      };

      //save exit note
      postNote(note, id)
        .then((res: any) => {
          const note_id = res[0].data.note_id;

          const exit = {
            exit_at: exitDate,
            exit_note_id: note_id,
          };

          deleteGuardian(id, userToDelete?.id, exit)
            .then((res: any) => {
              setShowToast(true);
              setToastText("Guardian Deleted");
              setToastBody(name);
              onDone();
              //delay
              setTimeout(() => {
                setIsDeleting(false);
              }, 1000);
            })
            .catch((err: any) => {
              console.log(err);
            });
        })
        .catch((err: any) => {
          console.log(err);
        });
    } else if (type === "Member") {
      const note = {
        notetype: "exit",
        subject: {
          id: userToDelete?.id,
          type: "member",
        },
        fields: {
          exit_type: exitType,
          description: exitNote,
          date: new Date().toISOString().split("T")[0],
        },
      };

      //save exit note
      postNote(note, id)
        .then((res: any) => {
          const note_id = res[0].data.note_id;

          const exit = {
            exit_at: exitDate,
            exit_note_id: note_id,
          };

          deleteMember(id, userToDelete?.id, exit)
            .then((res: any) => {
              setShowToast(true);
              setToastText("Guardian Deleted");
              setToastBody(name);
              onDone();
              //delay
              setTimeout(() => {
                setIsDeleting(false);
              }, 1000);
            })
            .catch((err: any) => {
              console.log(err);
            });
        })
        .catch((err: any) => {
          console.log(err);
        });
    }
  };

  const onClickDeleteFinal = () => {
    if (type === "Guardian") {
      deleteGuardian(id, userToDelete?.id)
        .then((res: any) => {
          setShowToast(true);
          setToastText("Guardian Deleted");
          setToastBody(name);
          onDone();
          //delay
          setTimeout(() => {
            setIsDeleting(false);
          }, 1000);
        })
        .catch((err: any) => {
          console.log(err);
        });
    } else if (type === "Member") {
      deleteMember(id, userToDelete?.id)
        .then((res: any) => {
          setShowToast(true);
          setToastText("Guardian Deleted");
          setToastBody(name);
          onDone();
          //delay
          setTimeout(() => {
            setIsDeleting(false);
          }, 1000);
        })
        .catch((err: any) => {
          console.log(err);
        });
    }
  };

  const onClickCancelDelete = () => {
    setIsDeleting(false);
  };

  return (
    <>
      <Card className="bg-light mb-3">
        <Card.Body>
          <Stack direction="horizontal" gap={3}>
            <Stack style={{ justifyContent: "center" }}>
              <Card.Subtitle>
                Are you sure you want to delete {userToDelete?.firstname} {userToDelete?.lastname}?
              </Card.Subtitle>
            </Stack>
            <Button
              className="app-danger-color button"
              onClick={() => {
                userToDelete?.exit_at ? onClickDeleteFinal() : onClickDeleteFinalWExit();
              }}
            >
              Confirm Delete
            </Button>
            <div className="vr" />
            <Button className="app-primary-color button" onClick={() => onClickCancelDelete()}>
              Cancel
            </Button>
          </Stack>
          {!userToDelete?.exit_at && (
            <>
              <div className="mt-3"></div>
              <ExitNote
                exitDate={exitDate}
                setExitDate={setExitDate}
                exitNote={exitNote}
                setExitNote={setExitNote}
                exitType={exitType}
                setExitType={setExitType}
                isBanned={false}
                setIsBanned={() => {}}
              />
            </>
          )}
        </Card.Body>
      </Card>
      <Row ref={mainRef} className="mb-5"></Row>
    </>
  );
};

export default ConfirmDelete;
